import React from 'react';
import { ButtonProps } from '../../types';

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  className = '', 
  href, 
  icon: Icon, 
  onClick,
  ...props 
}) => {
  const base = "inline-flex items-center justify-center ui-base font-semibold tracking-wide transition-all duration-500 ease-out transform active:scale-95 rounded-4xl no-underline leading-none relative overflow-hidden group";
  
  const variants = {
    primary: `
      bg-brand-primary text-brand-white
      hover:bg-brand-hover
      before:absolute before:inset-0 before:bg-gradient-to-r before:from-white/10 before:to-transparent before:translate-x-[-100%] before:group-hover:translate-x-[100%] before:transition-transform before:duration-1000
      py-4 px-8
    `,
    secondary: `
      bg-brand-white text-brand-dark border-2 border-brand-dark
      hover:bg-brand-dark
      hover:text-brand-white
      before:absolute before:inset-0 before:bg-gradient-to-r before:from-white/10 before:to-transparent before:translate-x-[-100%] before:group-hover:translate-x-[100%] before:transition-transform before:duration-1000
      py-4 px-8
    `,
    telegram: `
      bg-brand-telegram text-brand-white 
      shadow-lg 
      hover:bg-[#1C90C8] 
      hover:-translate-y-1
      hover:shadow-xl
      hover:rotate-1
      before:absolute before:inset-0 before:bg-gradient-to-br before:from-white/20 before:to-transparent before:opacity-0 before:group-hover:opacity-100 before:transition-opacity before:duration-500
      py-4 px-8
    `,
    text: `
      text-brand-dark hover:text-brand-primary 
      bg-transparent 
      hover:bg-white/50
      hover:scale-105
      backdrop-blur-sm
      py-2 px-2
    `,
  };

  const textClass = "relative z-10 flex items-center gap-2";

  const Component = href ? 'a' : 'button';
  const linkProps = href ? { 
    href, 
    target: "_blank", 
    rel: "noopener noreferrer" 
  } : { onClick };

  return (
    <Component className={`${base} ${variants[variant]} ${className}`} {...linkProps} {...props}>
      <span className={textClass}>
        {Icon && <Icon size={20} className="transition-transform group-hover:scale-110" />}
        {children}
      </span>
    </Component>
  );
};

export default Button;